(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["phb-konferenz-anfrage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__phbKonferenzAnfrage) return;
    window.__phbKonferenzAnfrage = true;

    var DEBUG = window.location.search.indexOf('phb_debug=1') !== -1;
    var PENDING_KEY = 'phb_ka_pending';
    var CLICK_KEYS = ['gclid', 'gbraid', 'wbraid'];
    var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

    function log() {
      if (DEBUG && window.console) console.log.apply(console, ['[phb-ka]'].concat([].slice.call(arguments)));
    }
    function push(payload) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      log('dataLayer.push', payload);
    }
    function ss(method, key, value) {
      try {
        if (method === 'get') return sessionStorage.getItem(key);
        if (method === 'set') sessionStorage.setItem(key, value);
        if (method === 'remove') sessionStorage.removeItem(key);
      } catch (e) {}
      return null;
    }
    function marketingAllowed() {
      try {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        return !!(cp && typeof cp.marketingAllowed === 'function' && cp.marketingAllowed());
      } catch (e) {
        return false;
      }
    }
    function analyticsAllowed() {
      try {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed());
      } catch (e) {
        return false;
      }
    }

    var root = document.querySelector('[data-phb-ka]');
    if (!root) return;
    var base = {
      form_name: root.getAttribute('data-form-name') || 'meetingraum_anfrage',
      form_location: root.getAttribute('data-form-location') || 'konferenzraum-landingpage',
      page_path: window.location.pathname
    };
    function withBase(obj) {
      var out = {};
      Object.keys(base).forEach(function (k) { out[k] = base[k]; });
      Object.keys(obj).forEach(function (k) { out[k] = obj[k]; });
      return out;
    }

    /* ---------- Attribution beim Landen einsammeln ---------- */
    var params = new URLSearchParams(window.location.search);
    var clickId = '';
    CLICK_KEYS.forEach(function (k) {
      if (!clickId && params.get(k)) clickId = k + ':' + params.get(k);
    });

    var utm = UTM_KEYS.map(function (k) {
      return params.get(k) ? k.replace('utm_', '') + '=' + params.get(k) : '';
    }).filter(Boolean).join(' | ');

    // Thema der Anzeigengruppe aus der URL, nur Kleinbuchstaben und Bindestrich
    var urlThema = (params.get('thema') || '').toLowerCase().replace(/[^a-z-]/g, '').slice(0, 40);

    // Im sessionStorage landen Klick-ID, UTM und Thema nur mit
    // Marketing-Einwilligung (§ 25 Abs. 1 TDDDG). Ohne Einwilligung liest das
    // Formular die Werte beim Absenden direkt aus der aktuellen URL.
    function persistAttribution() {
      if (!marketingAllowed()) return;
      if (clickId) ss('set', 'phb_click_id', clickId);
      if (utm && !ss('get', 'phb_utm')) ss('set', 'phb_utm', utm);
      if (urlThema) ss('set', 'phb_thema', urlThema);
    }
    persistAttribution();
    document.addEventListener('visitorConsentCollected', persistAttribution);

    /* ---------- Erfolg (nach Reload durch den POST) ---------- */
    var success = root.querySelector('[data-phb-ka-success]');
    if (success) {
      var pendingRaw = ss('get', PENDING_KEY);
      if (pendingRaw) {
        ss('remove', PENDING_KEY);
        var pending = {};
        try { pending = JSON.parse(pendingRaw) || {}; } catch (e) {}
        var payload = withBase({
          event: 'phb_form_success',
          paket: pending.paket || '',
          personen: pending.personen || '',
          vorlauf_tage: pending.vorlauf_tage,
          anzeigen_thema: pending.thema || ''
        });
        if (pending.email && root.getAttribute('data-ec') === 'true' && marketingAllowed()) {
          payload.user_data = { email: pending.email };
        }
        push(payload);
      } else {
        log('Erfolgsseite ohne offenes Absenden (Reload), kein Event');
      }
      root.scrollIntoView({ block: 'start' });
      success.focus({ preventScroll: true });
    }

    /* ---------- Formular ---------- */
    var form = root.querySelector('form.phb-ka__form');
    if (form && !success) {
      // Eigene Prüfung mit Markierung der Felder, die Browser-Blase kommt per reportValidity
      form.noValidate = true;
      var themaField = form.querySelector('[data-phb-ka-thema]');
      var quelleField = form.querySelector('[data-phb-ka-quelle]');
      var clickField = form.querySelector('[data-phb-ka-clickid]');

      form.addEventListener('submit', function (event) {
        var firstInvalid = null;
        form.querySelectorAll('[aria-invalid]').forEach(function (el) { el.removeAttribute('aria-invalid'); });
        form.querySelectorAll('input[required], select[required], textarea[required]').forEach(function (el) {
          if (!el.checkValidity()) {
            if (el.type === 'radio') {
              var group = el.closest('fieldset');
              if (group) group.setAttribute('aria-invalid', 'true');
            } else {
              el.setAttribute('aria-invalid', 'true');
            }
            if (!firstInvalid) firstInvalid = el;
          }
        });

        push(withBase({ event: 'phb_form_submit', valid: !firstInvalid }));

        if (firstInvalid) {
          event.preventDefault();
          firstInvalid.focus();
          if (firstInvalid.reportValidity) firstInvalid.reportValidity();
          return;
        }

        persistAttribution();
        var thema = urlThema || ss('get', 'phb_thema') || '';
        if (themaField) themaField.value = thema;
        if (quelleField) quelleField.value = utm || ss('get', 'phb_utm') || '';
        if (clickField) {
          var storedClick = ss('get', 'phb_click_id') || clickId;
          clickField.value = marketingAllowed() ? storedClick || '' : '';
        }

        var dateVal = (form.querySelector('input[type="date"]') || {}).value || '';
        var vorlauf;
        if (dateVal) {
          var diff = (new Date(dateVal + 'T12:00:00') - new Date()) / 86400000;
          vorlauf = Math.max(0, Math.round(diff));
        }
        var paketEl = form.querySelector('[data-phb-ka-choice] input[type="radio"]:checked');
        var personenEl = form.querySelector('select[name="contact[Personen]"]');
        var emailEl = form.querySelector('input[type="email"]');
        // Ohne Einwilligung kein Zwischenspeicher und damit kein Erfolgs-Event
        if (!marketingAllowed() && !analyticsAllowed()) return;
        ss('set', PENDING_KEY, JSON.stringify({
          paket: paketEl ? paketEl.value : '',
          personen: personenEl ? personenEl.value : '',
          vorlauf_tage: vorlauf,
          thema: thema,
          email: root.getAttribute('data-ec') === 'true' && marketingAllowed() && emailEl ? emailEl.value.trim().toLowerCase() : ''
        }));
      });

      form.addEventListener('input', function (event) {
        var el = event.target;
        if (el.getAttribute && el.getAttribute('aria-invalid') && el.checkValidity()) el.removeAttribute('aria-invalid');
        var group = el.closest && el.closest('fieldset[aria-invalid]');
        if (group && el.checked) group.removeAttribute('aria-invalid');
      });
    }

    /* ---------- Paket-Buttons belegen "Umfang" vor ---------- */
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[data-phb-paket]');
      if (!link || !form) return;
      var value = link.getAttribute('data-phb-paket');
      form.querySelectorAll('[data-phb-ka-choice] input[type="radio"]').forEach(function (radio) {
        radio.checked = radio.value === value;
      });
    });

    /* ---------- Klick-Tracking für CTAs, Telefon und E-Mail ---------- */
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link) return;
      var main = document.getElementById('MainContent');
      var inSticky = link.closest('[data-phb-kh-sticky]');
      if (!inSticky && (!main || !main.contains(link))) return;
      var href = link.getAttribute('href') || '';
      var where = link.getAttribute('data-phb-cta') || '';
      if (href.indexOf('tel:') === 0) push(withBase({ event: 'phb_phone_click', cta_location: where }));
      else if (href.indexOf('mailto:') === 0) push(withBase({ event: 'phb_email_click', cta_location: where }));
      else if (href === '#anfrage') push(withBase({ event: 'phb_cta_click', cta_location: where, paket: link.getAttribute('data-phb-paket') || '' }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["phb-konferenz-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSticky() {
      var bar = document.querySelector('[data-phb-kh-sticky]');
      var heroRoot = document.querySelector('[data-phb-kh]');
      if (!bar || !heroRoot || !('IntersectionObserver' in window)) return;
      // Beobachtet die Hero-Buttons: Liegen sie unter dem ersten Screen oder
      // sind sie weggescrollt, übernimmt die Leiste
      var hero = heroRoot.querySelector('.phb-kh__actions') || heroRoot;
      var form = document.getElementById('anfrage');
      var heroVisible = true;
      var formVisible = false;
      function update() {
        var show = !heroVisible && !formVisible;
        bar.hidden = !show;
        document.documentElement.classList.toggle('phb-kh-sticky-active', show);
      }
      new IntersectionObserver(function (entries) {
        heroVisible = entries[0].isIntersecting;
        update();
      }).observe(hero);
      if (form) {
        var target = form.closest('.shopify-section') || form;
        new IntersectionObserver(function (entries) {
          formVisible = entries[0].isIntersecting;
          update();
        }, { rootMargin: '0px 0px -20% 0px' }).observe(target);
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky);
    else initSticky();
  })();

  } catch(e) { console.error(e); }
})();
})();
